<div class="header">
  <span class="label">{{lightDevice.title}}</span>
  <ion-icon 
    size="medium" 
    src="assets/dropdown_arrow.svg" 
    class="arrow"
    (click)="onClose.emit()"
  ></ion-icon>
</div>

<div class="layout">
  <div class="range">
    <div class="range-header">
      <span class="range-label">Dimmer</span>
      <span class="range-value">{{ brightnessLabel }}</span>
    </div>
    <div class="range-track">
      <ion-range
        labelPlacement="stacked"
        [min]="minBrightness"
        [max]="maxBrightness"
        [(ngModel)]="lightBrightness"
        [disabled]="isBrightnessInvalid"
        (ionKnobMoveStart)="onBrightnessDragStart()"
        (ionKnobMoveEnd)="setBrightness($event)"
      ></ion-range>
      <span class="range-min" *ngIf="!isBrightnessInvalid">{{ minBrightness }}</span>
      <span class="range-max" *ngIf="!isBrightnessInvalid">{{ maxBrightness }}</span>
    </div>
  </div>
  <div class="range">
    <span class="range-label">Light Therapy</span>
    <range-colorpicker
      [currentColor]="selectedLightColor"
      (colorSelected)="setColor($event)"
    ></range-colorpicker>
  </div>

  <ion-radio-group
    [value]="selectedPresetValue"
    class="presets"
  >
    <ion-row class="presets-row">
      <ion-col size="auto" *ngFor="let preset of colorPresets" [class.preset-col--white]="!preset.canChange">
        <div class="presets_item">
          <ion-radio
            [value]="preset.id"
            [style]="getColor(preset.id)"
            [ngClass]="{ 'undefined': !preset.value }"
            (click)="onPresetTap(preset)"
          ></ion-radio>
          <ion-icon
            *ngIf="preset.canChange && preset.selected && !!preset.value"
            src="assets/recycle_bin.svg"
            class="delete-preset_btn"
            (click)="deletePreset(preset.id)"
          ></ion-icon>
        </div>
      </ion-col>
    </ion-row>

    <button
      class="save-preset_btn"
      *ngIf="isSavePresetBtnVisible"
      (click)="savePreset()"
    >{{savePresetBtnTitle}}</button>
  </ion-radio-group>
</div>